import type { SxProps } from '@mui/material/styles';

export const LEFT_PANEL_STYLES: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  flex: '0 1 60%',
  minHeight: 0,
  overflow: 'hidden',
  py: 2,
  pl: 0,
};

export const LEFT_PANEL_STYLES_FULL_WIDTH: SxProps = {
  ...LEFT_PANEL_STYLES,
  flex: 1,
};

export const RIGHT_PANEL_STYLES: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  flex: '0 1 40%',
  minHeight: 0,
  overflow: 'hidden',
  backgroundColor: 'background.boxLight',
  borderLeft: '1px solid',
  borderColor: 'divider',
};

export const SCROLLABLE_CONTAINER_STYLES: SxProps = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
};

export const TWO_PANEL_CONTAINER_STYLES: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  gap: 0,
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
};

export const SEARCH_FIELD_CONTAINER_STYLES: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 0,
  flex: 1,
};

export const SEARCH_FIELD_INPUT_WRAPPER_STYLES: SxProps = {
  position: 'relative',
  flexGrow: 1,
};

export const SEARCH_FIELD_CLEAR_BUTTON_STYLES: SxProps = {
  position: 'absolute',
  right: 8,
  top: '50%',
  transform: 'translateY(-50%)',
  padding: '4px',
};

export const getSearchFieldInputStyles = (
  hasPrefixElement: boolean,
  isHovered: boolean,
  hasValue: boolean
): SxProps => {
  // Room for the absolutely positioned clear button. SearchField never passes a `variant`, so the legacy TextField
  // renders a standard Input (`.MuiInput-*`); the design-system TextField is always an OutlinedInput, so the
  // `.MuiOutlinedInput-*` selectors only match the DS field.
  const clearButtonSpace = { paddingRight: hasValue ? '40px' : undefined };
  const baseStyles: SxProps = {
    '& .MuiInput-input': clearButtonSpace,
    '& .MuiOutlinedInput-input': clearButtonSpace,
  };

  if (hasPrefixElement) {
    return {
      '& .MuiInput-input': {
        borderLeft: 'none',
        ...clearButtonSpace,
        ...(isHovered && { backgroundColor: 'background.boxLight' }),
      },
      '& .MuiOutlinedInput-input': clearButtonSpace,
    };
  }

  return baseStyles;
};

export const DRAWER_CONTAINER_STYLES: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
};

export const DRAWER_HEADER_STYLES: SxProps = {
  mb: 0,
  '& .MuiButtonBase-root': { mr: 2, mt: 2 },
  '& .MuiTypography-root': { pl: 2, pt: 2 },
};
